import { Checkbox } from 'common-components'
import * as Styled from './styled'
import { CheckboxSize } from 'common-components/Checkbox/consts'

interface IHistoryScopeCheckboxProps {
  label: string
  isChecked: boolean
  onToggle: (next: boolean) => void
  sideMargin?: number
  isDisabled?: boolean
  className?: string
}

const HistoryScopeCheckbox = (props: IHistoryScopeCheckboxProps) => {
  const {
    label,
    isChecked,
    onToggle,
    sideMargin,
    isDisabled = false,
    className
  } = props

  return (
    <Styled.HistoryCheckboxWrapper sideMargin={sideMargin}>
      <Checkbox
        className={className}
        isChecked={isChecked}
        onChange={onToggle}
        label={label}
        isDisabled={isDisabled}
        size={CheckboxSize.md}
      />
    </Styled.HistoryCheckboxWrapper>
  )
}

export default HistoryScopeCheckbox
